import { useContext } from 'react';
import { TextInput, Loading } from '@zopauk/web-ui';
import type { ChangeEvent, FocusEvent } from 'react';
import { CalculatorContext } from '@/components/Calculator/Context';

export const Amount = ({ id }: Record<'id', string>) => {
  const context = useContext(CalculatorContext);

  if (!context.pricing) {
    return (
      <div className="flex justify-center items-center">
        <Loading className="text-primary" />
      </div>
    );
  }

  return (
    <header className="mb-5">
      <div className="mb-2 mt-4 text-center">
        <div className="w-3/7 mx-auto text-2xl">
          <TextInput
            startIcon={<span className="material-symbols-outlined text-primary lg:ml-2">currency_pound</span>}
            onBlur={(e: FocusEvent<HTMLInputElement>) => context.setAmount(e.currentTarget.value, true)}
            onChange={(e: ChangeEvent<HTMLInputElement>) => context.setAmount(e.currentTarget.value)}
            aria-label="Loan amount in pounds"
            data-automation="ZA.input-amount"
            className="border-primary"
            id={`loan-amount-${id}`}
            name="loan-amount-input"
            value={context.amount}
            inputMode="numeric"
            pattern="[0-9]+"
          />
        </div>
      </div>
    </header>
  );
};
